import { EmptyBox, FlexColumn, FlexRow, FlexRowBetween } from 'components'
import { AppPrimaryButton } from 'elements'
import { CaretDown, CaretUp } from 'phosphor-react'
import React, { useEffect, useState } from 'react'
import { Accordion, AccordionContent, AccordionTitle, CardContent, Checkbox, Divider, Form, Input, Label, Table } from 'semantic-ui-react'
import styled from 'styled-components'
import { CommanReportComponentType, CommonUtility, CustomReportStepKeys, MediaService, ReportService } from 'utility'
import { AboutUs, CompanyHeader, CustomerDetail, FileUpload, LocationDetail, TextboxWithBulletPoint, TextBoxWithHeader, SectionResult, TextAreaWithEditor } from './elements'
import { useNavigate } from 'react-router-dom'

const FormContainer = styled.div`
.section-name {
    background: ${({ theme }) => theme.colors.primary} !important;
    color: ${({ theme }) => theme.colors.white} !important;
}
`

const Row = ({ item, onSelect }) => (
    <Table.Row onClick={() => onSelect(item.SubsectionID)}>
        <Table.Cell>
            <Checkbox checked={item.Selected} onChange={onSelect} />
        </Table.Cell>
        <Table.Cell>
            {item.SectionName} - {item.SubsectionName}
        </Table.Cell>
    </Table.Row>
)
const TableConatiner = styled.div`
.label {
    a {
        opacity: 1;
    }
}
`
export const ComponentListTable = ({ data = [], loading, onSelect }) => {
    const onAllSelect = (_, e) => {
        onSelect("", e.checked)
    }
    return (
        <TableConatiner>
            <Table celled>
                <Table.Header>
                    <Table.Row active>
                        <Table.HeaderCell textAlign="center"><FlexRow className="align-items-center"><Checkbox checked={data.every(ele => ele.Selected)} onChange={onAllSelect} /><span className="ms-5">Select</span></FlexRow></Table.HeaderCell>
                        <Table.HeaderCell textAlign="center">Component</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {data?.map((item) => <React.Fragment key={item.SubsectionID}><Row
                        item={item}
                        onSelect={() => onSelect(item.SubsectionID)}
                    /></React.Fragment>)}
                </Table.Body>
            </Table>
            {data && !data.length && !loading && <EmptyBox />}
        </TableConatiner>
    )
}

const getFormField = (item, templateData, onSectionSelect, onAnswer) => {
    const submitAnswer = (answer) => {
        const answerData = {
            DisplayOrder: (item.Answers || []).length,
            UniqueId: answer.UniqueId,
            TemplateId: templateData.AuditTemplateId,
            ChartOption: 0,
            ...answer,
        }
        onAnswer(item.SectionID, item.SubsectionID, answerData)
    }
    const name = CommonUtility.getFieldName(item)
    switch (Number(item.ComponentType)) {
        case CommanReportComponentType.AboutUs: return <AboutUs item={item} name={name} submitAnswer={submitAnswer} />;
        case CommanReportComponentType.CompanyHeader: return <CompanyHeader submitAnswer={submitAnswer} />;
        case CommanReportComponentType.CompanyLogo: return <FileUpload item={item} submitAnswer={submitAnswer} onSectionSelect={onSectionSelect} />;
        case CommanReportComponentType.ReportCustomerDetail: return <CustomerDetail submitAnswer={submitAnswer} customer={templateData.ReportCustomerDetail} />;
        case CommanReportComponentType.ReportLocationDetail: return <LocationDetail submitAnswer={submitAnswer} location={templateData.ReportLocationDetail} />;
        case CommanReportComponentType.SectionResult: return <SectionResult item={item} submitAnswer={submitAnswer} templateData={templateData} onSectionSelect={onSectionSelect} />;
        case CommanReportComponentType.TextAreaWithEditor: return <TextAreaWithEditor submitAnswer={submitAnswer} name={name} item={item} onSectionSelect={onSectionSelect} />;
        case CommanReportComponentType.TextboxWithBulletPoint: return <TextboxWithBulletPoint submitAnswer={submitAnswer} item={item} name={name} onSectionSelect={onSectionSelect} />;
        case CommanReportComponentType.ImagePickup: return <FileUpload item={item} submitAnswer={submitAnswer} onSectionSelect={onSectionSelect} />;
        case CommanReportComponentType.TableSummary: return <FileUpload item={item} submitAnswer={submitAnswer} onSectionSelect={onSectionSelect} />;
        case CommanReportComponentType.TextBoxWithHeader: return <TextBoxWithHeader submitAnswer={submitAnswer} item={item} onSectionSelect={onSectionSelect} />;
        default: return ""
    }
}

const GetComponentBox = ({ item, templateData, onSectionSelect, onAnswer }) => {
    const [open, setOpen] = useState(true)
    const toggleSection = () => {
        setOpen(!open)
    }
    return (
        <Accordion fluid styled className="mt-4">
            <AccordionTitle
                active={open}
                index={item.SectionId}
                onClick={toggleSection}
                className="section-name"
            >
                <FlexRowBetween><FlexRow className="align-items-center">
                    <span onClick={() => setOpen(!open)}>{item.SectionName} - {item.SubsectionName} {item.IsRequired && <Label>Required</Label>}</span>
                </FlexRow>
                    <span>{open ? <CaretDown size={20} /> : <CaretUp size={20} />}</span>
                </FlexRowBetween>
            </AccordionTitle>
            <AccordionContent className="outer-box" active={open}>
                <Divider className="my-0 mb-3" />
                <CardContent className="row p-0 ">
                    {getFormField(item, templateData, onSectionSelect, onAnswer)}
                </CardContent>
            </AccordionContent>
        </Accordion>)
}

export const CustomeReportList = ({ templateData, list, onSectionSelect, onAnswer }) => {
    return (
        <Form>
            {list?.map(ele =>
                <div key={ele.SubsectionID}>
                    <GetComponentBox
                        item={ele}
                        templateData={templateData}
                        onSectionSelect={onSectionSelect}
                        onAnswer={onAnswer}
                    />
                </div>,
            )}
        </Form>
    )
}

export const FormSteps = ({ sectionList, componentList, onSectionSelect, onDataAdd, onStepChange, activeStep }) => {
    const [list, setList] = useState(sectionList?.ReportComponentSection || [])
    const [name, setName] = useState("")
    const navigate = useNavigate()
    useEffect(() => {
        setList(sectionList?.ReportComponentSection)
    }, [sectionList])

    useEffect(() => {
        if (list.filter(ele => ele.Selected).length) {
            onStepChange(CustomReportStepKeys.Component)
        }
    }, [])

    const onSelect = (id, all = false) => {
        if (!id) {
            setList(list.map(item => ({ ...item, Selected: all })))
            return
        }
        setList(list.map(item => ({ ...item, Selected: id === item.SubsectionID ? !item.Selected : item.Selected })))
    }

    const onAnswer = (sectionId, subSectionId, answer) => {
        if (sectionId && subSectionId) {
            let answerList = [...list]
            answerList = answerList.map(ele => {
                if (ele.SectionID === sectionId && ele.SubsectionID === subSectionId) {
                    const ansList = ele?.Answers?.length ? ele.Answers : [answer];
                    if (answer.New) {
                        ansList.push(answer)
                    }
                    return {
                        ...ele,
                        Answers: ansList.map(item => {
                            if (item.UniqueId === answer.UniqueId) {
                                return { ...answer }
                            }
                            return item
                        }),
                    }
                }
                return ele
            })
            setList(answerList)
        }
    }

    const uploadFiles = async (files) => {
        let result = []
        try {
            result = await Promise.all(files?.map(async (ele) => {
                const data = await MediaService.uploadMedia({ media: ele })
                return data
            }))
        } catch (error) {
            console.log("error:", error)
        }
        return result
    }

    const submit = async () => {
        const sectionData = [];
        const promises = await Promise.all(list.filter(ele => ele.Selected).map(async (item) => {
            const commonData = {
                SubsectionID: item.SubsectionID,
                SectionID: item.SectionID,
                SubsectionName: item.SubsectionName,
                SectionName: item.SectionName,
                DisplayOrder: item.DisplayOrder,
                ComponentType: Number(item.ComponentType),
                TemplateSectionId: "",
                UniqueId: 0,
                Images: [],
                Answers: [],
            }
            if ([CommanReportComponentType.ImagePickup, CommanReportComponentType.CompanyLogo].includes(Number(item.ComponentType))) {
                if (item?.Answers?.[0]?.Files && item?.Answers?.[0]?.Files.length) {
                    const images = await uploadFiles(item?.Answers?.[0]?.Files);
                    return {
                        ...commonData,
                        Images: images.map((ele, i) => ({
                            ImageId: 0,
                            SubsectionID: item.SubsectionID,
                            SectionID: item.SectionID,
                            ImagePathUrl: ele.ImagePathUrl,
                            DisplayOrder: i,
                            ImageTitle: "",
                            ReportId: 0,
                            CloudImageId: ele.CloudImageId,
                        })),
                    }
                }
                return ""
            }
            if (CommanReportComponentType.SectionResult === Number(item.ComponentType)) {
                if (item?.Answers?.[0].TemplateSectionId?.length) {
                    item?.Answers?.[0].TemplateSectionId.forEach(item => {
                        sectionData.push({
                            ...commonData,
                            Images: [],
                            TemplateSectionId: item.SectionId,
                            Answers: [{
                                Header: "",
                                Answer: "",
                                DisplayOrder: 0,
                                ResultId: 0,
                                ChartOption: item.ChartOption,
                                UniqueId: 0,
                                TemplateId: sectionList.TemplateData.AuditTemplateId,
                            }],
                        })
                    })
                }
                return ""
            }
            return { ...commonData, Answers: item.Answers?.map(ele => ({ Header: "", ResultId: 0, ...ele, UniqueId: 0 })) || [] }
        }))
        const Sections = [...promises.filter(ele => ele), ...sectionData]
        await ReportService.addCustomeReport({
            TemplateId: sectionList.TemplateData.AuditTemplateId,
            ReportTitle: name,
            ReportId: 0,
            Sections,
        })
        navigate(`/app/templates/inspection/report/${sectionList.TemplateData.AuditTemplateId}?customeReport=true`)
    }

    return (<FormContainer className="form mt-5">
        {
            activeStep === CustomReportStepKeys.Component && <>
                <FlexColumn className="mb-3">
                    <label>Report Name</label>
                    <Input onChange={(_, val) => setName(val.value)} value={name} />
                </FlexColumn>
                <ComponentListTable data={list} onSelect={onSelect} />
                <FlexRow className="justify-content-end mt-3">
                    <AppPrimaryButton onClick={() => onStepChange(CustomReportStepKeys.Form)}>Next</AppPrimaryButton>
                </FlexRow>
            </>
        }
        {
            activeStep === CustomReportStepKeys.Form && <>
                <CustomeReportList
                    list={list.filter(ele => ele.Selected)}
                    templateData={sectionList.TemplateData}
                    componentList={componentList}
                    onSectionSelect={onSectionSelect}
                    onDataAdd={onDataAdd}
                    onAnswer={onAnswer}
                />
                <FlexRowBetween className="mt-3">
                    <AppPrimaryButton onClick={() => onStepChange(CustomReportStepKeys.Component)}>Back</AppPrimaryButton>
                    <AppPrimaryButton onClick={() => submit()}>Submit</AppPrimaryButton>
                </FlexRowBetween>
            </>
        }
    </FormContainer>)
}